<template>
  <div id="manage">
    <div class="content">
        <div class="title">展演管理</div>
        <div class="botBox">
            <div class="bottomBox">
                <div class="selVox">
                    <div class="fl_left">
                        <input type="password"  autocomplete="new-password" style="display: none;">
                        <Input
                        id="demo"
                        v-model="searchModel.keyword"
                        icon="ios-search"
                        placeholder="输入关键字搜索"
                        style="width: 200px;height:34px;border:1px solid #e7e7eb;margin:20px 0;"
                        class="bradius"
                        @on-click="getPerformanceList(1)"
                        @keyup.enter.native="getPerformanceList(1)"
                        autocomplete="off"></Input>
                        <Select v-model="searchModel.group" clearable placeholder="请选择展演分组" class="borDiv" style="width:200px;border:1px solid #e7e7eb;margin:20px 0;" @on-change="getPerformanceList(1)">
                            <Option v-for="item in groupArr" :value="item.id" :key="item.id">{{ item.title }}</Option>
                        </Select>
                    </div>
                    <div class="fl_right addClass" @click="addPerformance">新增展演</div>
                </div>
                <div class="bottom" style="border:1px solid #e6e6e6;box-sizing: border-box;">
                    <Table :columns="performanceColumns" :data="performanceList" :loading="loading"></Table>
                    <Page :page-size="pageSize" :total="total" show-total :current="searchModel.page" @on-change="updatePage" style="position:absolute;bottom:20px;left:38%;"></Page>
                </div>
            </div>
            <!-- 添加 -->
            <div class="alertBox" v-if="alertShow" style="padding-top:3%;">
                <div class="tanchuan" style="width:780px;overflow:hidden;">
                    <div class="tantop">
                        <div class="fl_left tantitle">展演</div>
                        <div class="fl_right tandel" @click="tandel"></div>
                        <div class="clear"></div>
                    </div>
                    <div style="height:80vh;">
                        <div class="tancenter" style="overflow-y:auto;height: 100%;padding-bottom: 30px;">
                            <div class="list listpad">
                                <div class="fl_left name">展演名称<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Input v-model="addModel.name" class="bordiv" size="large" autocomplete="off" style="width:440px;" placeholder="请输入名称" />
                                    <input type="text"  autocomplete="off" name="" style="display:none">
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">展演介绍</div>
                                <div class="fl_left ">
                                    <Input v-model="addModel.introduce" class="bordiv" :autosize="{minRows: 3}" resize
                                        type="textarea" placeholder="请输入" style="width: 440px;height:auto" />
                                    <input type="text" autocomplete="off" name="" style="display:none">
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">承办单位<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <Select v-model="addModel.company_id" class="bordiv" placeholder="请选择承办单位" filterable style="width:440px;">
                                        <Option v-for="item in companyList" :key="item.id" :value="item.id" >{{ item.name}}</Option>
                                    </Select>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">展演分组<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <RadioGroup v-model="addModel.group">
                                        <Radio :label="item.id" v-for="(item,index) in groupArr" :key="index">{{ item.title }}</Radio>
                                    </RadioGroup>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="list listpad">
                                <div class="fl_left name">报名时间<span style="color:#c30d23;font-weight: bold;font-size: 18px;"> *</span></div>
                                <div class="fl_left inputBox">
                                    <el-date-picker
                                        v-model="addDate"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                    </el-date-picker>
                                </div>
                                <div class="clear"></div>
                            </div>
                            <div class="tanBtn" @click="savePerformance">确定</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'manage',
        data () {
            return {
                //搜索model
                searchModel:{
                    keyword:"",
                    page:1,
                    group:'',//展演分组：0地级市展演 1总展演
                },
                //添加model
                addModel:{
                    performance_id:'',
                    name:"",
                    introduce:'',
                    company_id:"",
                    group:'',
                    start_date:'',
                    end_date:'',
                },
                //展演分组
                groupArr:[
                    {title:'地级市展演',id:0},
                    {title:'总展演',id:1},
                ],
                addDate:['',''],
                imgd1:'',
                cropShow:false,
                provinceArr:[],
                cities:[],
                total:null,
                pageSize:10,
                loading:false,
                performanceColumns: [
                    {
                        title: '序号',
                        type: 'index',
                        align: 'center',
                        width:80
                    },

                    {
                        title: '名称',
                        align: 'center',
                        key: 'name'
                    },
                    {
                        title: '介绍',
                        align: 'center',
                        key: 'introduce'
                    },
                    {
                        title: '承办单位',
                        align: 'center',
                        key: 'company'
                    },
                    {
                        title: '报名二维码',
                        align: 'center',
                        key: 'level',
                        render: (h, params) => {
                            if(params.row.status==1||params.row.status==0){
                                return h('div',[
                                    h('div',{
                                        // style:{
                                        //     color:'#999',
                                        // }
                                    },params.row.level),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                if(params.row.status==1){
                                                    this.$Modal.success({
                                                        title: '扫描二维码报名',
                                                        render: (h) => {
                                                            return h('div',[
                                                                h('Img', {
                                                                    attrs: {
                                                                        src:params.row.qrcode,
                                                                    },
                                                                    style:{
                                                                        border:'1px solid #dcdcdc',
                                                                        width:'200px',
                                                                        display:'block',
                                                                        margin:'0 auto'
                                                                    },
                                                                    on: {
                                                                    }
                                                                }),
                                                                h('div',{
                                                                    style:{
                                                                        textAlign:'center',
                                                                        lineHeight:'50px'
                                                                    },
                                                                },params.row.name),
                                                                h('div',{
                                                                    style:{
                                                                        textAlign:'left',
                                                                        // marginBottom:'100px'
                                                                    },
                                                                },[
                                                                    h('div',{
                                                                        style:{
                                                                            padding:'8px 10px',
                                                                            border:'1px solid #dcdcdc',
                                                                            borderRadius:'4px',
                                                                            backgroundColor:'#e3e3e5',
                                                                            margin:'0 auto',
                                                                            cursor:'pointer',
                                                                            width:'100px',
                                                                            textAlign:'center'
                                                                        },
                                                                        on: {
                                                                            click: () => {
                                                                                this.copyUrl()
                                                                            }
                                                                        }
                                                                    },'复制网址'),
                                                                    h('a',{
                                                                        style:{
                                                                            color:'#1890ff',
                                                                            width:'260px',
                                                                            wordBreak:'break-word',
                                                                            float:'left',
                                                                            opacity:'0'
                                                                        },
                                                                        attrs:{
                                                                            href:params.row.jump_url,
                                                                            target:'_blank',
                                                                            id:'inviteCode'
                                                                        }
                                                                    },params.row.jump_url),
                                                                ])
                                                            ])
                                                        },
                                                        onOk: () => {

                                                        },
                                                        onCancel: () => {
                                                            // this.search(0)
                                                        }
                                                    })
                                                }
                                                else{
                                                    this.$Modal.confirm({
                                                        title: '提示',
                                                        content: '<p>确定要开启报名?</p>',
                                                        okText: '确定',
                                                        cancelText: '取消',
                                                        onOk: () => {
                                                            _this.$axios.post('chanperformancestatus',{
                                                                performance_id:params.row.id
                                                            }).then(res=>{
                                                                if(res.data.code==200){
                                                                    _this.$Message.success('操作成功');
                                                                    _this.getPerformanceList(0);
                                                                 }
                                                                 else{
                                                                     this.$Message.error(res.data.message);
                                                                 }
                                                            }).catch(function (error) {
                                                              console.log(error);
                                                            });
                                                        },
                                                        onCancel: () => {
                                                            // this.$Message.info('取消');
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    }, '查看二维码'),
                                ]);
                            }
                            else{
                                return h('div',"-")
                            }
                        }
                    },

                    {
                        title: '时间',
                        align: 'center',
                        key: 'linkman',
                        render: (h, params) => {
                            return h('div', params.row.date_show);
                        }
                    },

                    {
                        title: '节目名单',
                        align: 'center',
                        key: 'name',
                        render: (h, params) => {
                            return h('div', [
                                h('button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                    },
                                    style: {
                                        backgroundColor:'rgba(0,0,0,0)',
                                        border:'none',
                                    },
                                    on: {
                                        click: () => {
                                            let _this=this;
                                            let luder = JSON.stringify(_this.searchModel);
                                            localStorage.setItem("luder", luder);
                                            this.$router.push({
                                                path:'/performance/index/programlist',
                                                query:{
                                                    performance_id:params.row.id,
                                                }
                                            })
                                        }
                                    }
                                },  '点击查看' + '(' + params.row.programs_count + ')')
                            ]);
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div',{
                                    style:{
                                        color:'#49c00e',
                                    }
                                },'报名中');
                            }
                            else if(params.row.status==0){
                                return h('div',{
                                    style:{
                                        color:'#999',
                                    }
                                },'未开启报名');
                            }
                            else if(params.row.status==2){
                                return h('div',{
                                    style:{
                                        color:'#999',
                                    }
                                },'已结束');
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            margin:'0 5px',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                let str=params.row.status==1?'关闭':'开启';
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要'+str+'报名?</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('chanperformancestatus',{
                                                            performance_id:params.row.id
                                                        }).then(res=>{
                                                            if(res.data.code==200){
                                                                _this.$Message.success('操作成功');
                                                                _this.getPerformanceList(0);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, params.row.status==1?'关闭报名':'开启报名'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                            marginRight:'10px'
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                _this.addModel = params.row;
                                                _this.addModel.performance_id = params.row.id;
                                                _this.addDate = [];
                                                _this.addDate.push(new Date(params.row.start_date));
                                                _this.addDate.push(new Date(params.row.end_date));
                                                _this.alertShow=true;
                                            }
                                        }
                                    }, '编辑'),
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要删除这个报名?</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('deleteperformance',{performance_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                this.getPerformanceList(0)
                                                                this.$Message.success('删除成功');
                                                            }
                                                            else{
                                                                this.$Message.error(res.data.message);
                                                            }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '删除'),
                                ]);
                            // }
                        }
                    },
                    {
                        title: '导出',
                        align: 'center',
                        key: 'bespeak_count',
                        render: (h, params) => {
                            // if(params.row.status==0){
                                return h('div', [
                                    h('button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            backgroundColor:'rgba(0,0,0,0)',
                                            border:'none',
                                        },
                                        on: {
                                            click: () => {
                                                let _this=this;
                                                this.$Modal.confirm({
                                                    title: '提示',
                                                    content: '<p>确定要导出报名汇总表?</p>',
                                                    okText: '确定',
                                                    cancelText: '取消',
                                                    onOk: () => {
                                                        _this.$axios.post('getuploadperformanceuserurl',{performance_id:params.row.id}).then(res=>{
                                                            if(res.data.code==200){
                                                                window.open(res.data.data);
                                                             }
                                                             else{
                                                                 this.$Message.error(res.data.message);
                                                             }
                                                        }).catch(function (error) {
                                                          console.log(error);
                                                        });
                                                    },
                                                    onCancel: () => {
                                                        // this.$Message.info('取消');
                                                    }
                                                });
                                            }
                                        }
                                    }, '报名汇总表'),
                                ]);
                            // }
                        }
                    },
                ],
                performanceList: [],
                alertShow:false,
                companyList: [],
            }
        },
        methods:{
            tandel(){
                this.alertShow=false;
            },
            //获取列表
            getPerformanceList(index){
                let _this=this;
                if(index==1){
                    _this.searchModel.page=1;
                }
                _this.$axios.post('getperformancelist',_this.searchModel).then(res=>{
                    if(res.data.code==200){
                        _this.total=res.data.data.total;
                        _this.performanceList=res.data.data.list;

                        _this.loading=false;
                    }
                    else{
                        _this.loading=false;
                        this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            updatePage(num) {
                this.searchModel.page = num;
                this.getPerformanceList(0);
            },
            //添加
            addPerformance(){
                let _this  = this;
                _this.addModel = {
                    performance_id:'',
                    name:"",
                    introduce:'',
                    group:'',
                    start_date:'',
                    end_date:'',
                };
                _this.addDate='';
                _this.alertShow=true;
            },
            //获取承办单位列表
            getCompanyList(){
                let _this=this; 
                _this.$axios.post('getcompanyselect',{}).then(res=>{
                    if(res.data.code==200){
                        _this.companyList=res.data.data;
                    }
                    else{
                        _this.$Message.error(res.data.message);
                    }
                }).catch(function (error) {
                  console.log(error);
                });
            },
            //保存
            savePerformance(){
                let _this=this;
                if(_this.addModel.name==''){
                    _this.$Message.error('请输入名称');
                }
                else if(_this.addModel.group === ''){
                    _this.$Message.error('请选择分组');
                }
                else if(_this.addDate[0]==''){
                    _this.$Message.error('请选择报名时间');
                }
                else if(_this.addModel.company_id==''){
                    _this.$Message.error('请选择承办单位');
                }
                else{
                    _this.addModel.start_date   = _this.addDate[0];
                    _this.addModel.end_date     = _this.addDate[1];
                    const loading = this.$loading({
                        lock: true,
                        text: '加载中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    let _url    = "addperformance";
                    _this.$axios.post(_url,_this.addModel).then(res=>{
                        loading.close();
                        if(res.data.code==200){
                            _this.alertShow=false;
                            _this.getPerformanceList(0);
                        }
                        else{
                            _this.$Message.error(res.data.message);
                        }
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            },
            //复制网址
            copyUrl(data){
                var Url2 = document.getElementById("inviteCode").innerText;
                var oInput = document.createElement("input");
                oInput.value = Url2;
                document.body.appendChild(oInput);
                oInput.select(); // 选择对象
                document.execCommand("Copy"); // 执行浏览器复制命令
                oInput.className = "oInput";
                oInput.style.display = "none";
                this.$Message.success('复制成功！');
            },
        },
        created(){
            let _this=this;
            let luder = JSON.parse(localStorage.getItem("luder"));
            if(luder!=null){
                _this.searchModel = luder;
            }
            _this.getPerformanceList();
            _this.getCompanyList();
        }
    }
</script>

<style scoped>
/**/
    .codeBtn{
        cursor:pointer;
        position: absolute;
        top: 2px;
        right: 0;
        width: 90px;
        height: 30px;
        background-color: #ffffff;
        border: solid 1px #dc4e5a;
        color: #dc4e5a;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
    }
    .selVox{
        overflow: hidden;
        height: 80px;
        line-height: 80px;
    }
    .add {
        width: 150px;
        height: 150px;
        float: left;
        cursor: pointer;
        background: url(../../../static/imgs/logoadd.png) no-repeat;  /*// 这里使用的是我本地图片*/
        background-size: 100% 100%;
    }
/**/
    /* .urlLogo{
        width: 150px;
        height: 210px;
        background: #f5f5fa url('../../../static/imgs/baadd.png') center center/30px no-repeat;
        border: solid 1px #e5e5e5;
        position: relative;
        overflow: hidden;
    } */
    .urlLogo1{
        width: 150px;
        height: 150px;
        border: solid 1px #e5e5e5;
    }
    .urlLogo input{
        position: absolute;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0;
    }
    .urlLogo img{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        /*z-index: 999;*/
    }
    .borDiv{
        border: 1px solid #e7e7eb;
        border-radius: 4px;
        overflow: hidden;
        width: 290px;
    }
    .name{
        line-height: 36px;
        text-align: right;
        color: #333;
        margin-right: 16px;
        width: 116px;
    }
    .wzbarBox{
      /* width: 134px; */
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      align-items:center;
      height: 61px;
    }
    .wzbar{
      color: #999;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      flex-direction:column;
      line-height: 58px;
      cursor: pointer;
      margin-right: 20px;
    }
    .wzbar>span{
      display: block;
      width: 55px;
      height: 3px;
      background-color: #f6f6f6;
    }
    .wzbars{
      color: #c30d23;
    }
    .wzbars>span{
      background-color: #c30d23;
    }
    .title{
        line-height: 68px;
        color: #303030;
        font-size: 18px;
    }
    .content,#manage{
        width: 100%;
    }
    .botBox{
        width: 100%;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
        min-height: 785px;
        position: relative;
        border:1px solid #e6e6e6;
    }
    .center,.bottomBox{
        padding: 0 20px;
        box-sizing: border-box;
    }
    .top,.center,.bottom,.bottomBox{
        width: 100%;
    }
    .top{
        height: 62px;
        line-height: 62px;
        border-bottom: 1px solid #e6e6e6;
        /*padding: 0 20px;*/
        box-sizing: border-box;
        position: relative;
        margin-bottom: 25px;
    }
    .showBox{
        position: absolute;
        right: 20px;
        top:65px;
        z-index: 99;
    }
    .shdawBot{
        padding: 0 30px 15px;
        box-sizing: border-box;
    }
    .addClass{
        width: 132px;
        height: 36px;
        border-radius: 2px;
        background-color: #c30d23;
        color: #fff;
        line-height: 36px;
        text-align: center;
        margin-top: 22px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/performance/index.vue